"use client";

import { c as _c } from "react/compiler-runtime";
import type { Collection } from "@/features/collections/types";
import { useLikeToggle } from "@/features/likes/useLikeToggle";
import { useWatchlistToggle } from "@/features/watchlist/useWatchlistToggle";

/** Like and watchlist for the collection — the shared toggles with the
 *  legacy messages and guest login, so every like control on the site agrees
 *  about this collection and both page designs post the same thing. */
export function useLikeWatch(collection, isFa) {
  const $ = _c(16);
  const t0 = collection.current_user?.like ?? false;
  const t1 = collection.likes?.count ?? 0;
  const t2 = isFa ? "\u062E\u0637\u0627 \u062F\u0631 \u062B\u0628\u062A \u067E\u0633\u0646\u062F" : "Failed to update like";
  let t3;
  if ($[0] !== collection.id || $[1] !== t0 || $[2] !== t1 || $[3] !== t2) {
    t3 = {
      modelType: "collection",
      modelId: collection.id,
      initialLiked: t0,
      initialCount: t1,
      errorMessage: t2
    };
    $[0] = collection.id;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const like = useLikeToggle(t3);
  const t4 = collection.current_user?.watchlist ?? false;
  const t5 = isFa ? "\u0628\u0647 \u0648\u0627\u0686\u200C\u0644\u06CC\u0633\u062A \u0627\u0636\u0627\u0641\u0647 \u0634\u062F" : "Added to watchlist";
  const t6 = isFa ? "\u0627\u0632 \u0648\u0627\u0686\u200C\u0644\u06CC\u0633\u062A \u062D\u0630\u0641 \u0634\u062F" : "Removed from watchlist";
  let t7;
  if ($[5] !== t5 || $[6] !== t6) {
    t7 = {
      added: t5,
      removed: t6
    };
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = isFa ? "\u062E\u0637\u0627 \u062F\u0631 \u062B\u0628\u062A \u0648\u0627\u0686\u200C\u0644\u06CC\u0633\u062A" : "Failed to update watchlist";
  let t9;
  if ($[8] !== collection.id || $[9] !== t4 || $[10] !== t7 || $[11] !== t8) {
    t9 = {
      modelType: "collection",
      modelId: collection.id,
      initialWatchlisted: t4,
      successMessage: t7,
      errorMessage: t8
    };
    $[8] = collection.id;
    $[9] = t4;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const watch = useWatchlistToggle(t9);
  let t10;
  if ($[13] !== like || $[14] !== watch) {
    t10 = {
      like,
      watch
    };
    $[13] = like;
    $[14] = watch;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}